/**
 * Read more/Read less functionality for rich text content
 *
 * This file handles the collapsible "Read more"/"Read less" functionality.
 */

document.addEventListener('DOMContentLoaded', function() {
  // Initialize all read-more content blocks on the page
  document.querySelectorAll('.read-more-content').forEach(initializeReadMoreContent);
});

/**
 * Initialize a read-more content block
 * @param {HTMLElement} container - The read-more content container
 */
function initializeReadMoreContent(container) {
  if (!container) return;

  const content = container.querySelector('.read-more-content__inner');
  const button = container.querySelector('.read-more-content__button');

  if (!content || !button) return;

  const initialHeight = parseInt(container.dataset.initialHeight || 125);
  const contentHeight = content.offsetHeight;

  // Only apply collapse functionality if content is taller than the initial height
  // or if auto-detect is disabled (auto-detect is true by default)
  const autoDetect = container.dataset.autoDetect !== 'false';
  const shouldCollapse = !autoDetect || contentHeight > initialHeight;

  if (shouldCollapse) {
    // Initialize as collapsed
    container.classList.add('read-more-content--collapsed');

    // Handle button click
    button.addEventListener('click', function() {
      const isExpanded = button.getAttribute('aria-expanded') === 'true';

      // Toggle state
      button.setAttribute('aria-expanded', !isExpanded);
      container.classList.toggle('read-more-content--collapsed');
    });
  } else {
    // If content is not tall enough to need collapsing and auto-detect is enabled
    button.parentElement.style.display = 'none';
  }
}
